import React from "react"
import type { WizardQuestion } from "../../../types"
import { GROUP_META } from "../constants"

interface Props {
  question: WizardQuestion
  index: number
  total: number
  value: boolean | undefined
  onAnswer: (key: string, value: boolean) => void
  onBack: () => void
}

// Uma pergunta por vez, botões grandes, avanço automático ao responder.
export default function QuestionStep({ question, index, total, value, onAnswer, onBack }: Props) {
  return (
    <section>
      <p className="text-sm font-semibold text-brand-700 uppercase tracking-wide">
        Pergunta {index + 1} de {total}
      </p>
      <h1 className="mt-3 font-display text-2xl sm:text-3xl font-semibold text-ink leading-snug">
        {question.label}
      </h1>
      <p className="mt-3 text-sm text-gray-500">
        Se sim, seu plano cobre{" "}
        {question.residue_groups.map(g => GROUP_META[g].name).join(" e ")}
        {" "}({question.residue_groups.map(g => GROUP_META[g].description.toLowerCase()).join("; ")}).
      </p>

      <div className="mt-8 grid grid-cols-2 gap-4 max-w-md">
        <button
          type="button"
          onClick={() => onAnswer(question.key, true)}
          className={`rounded-2xl border-2 px-6 py-6 text-lg font-semibold transition ${
            value === true
              ? "border-brand-600 bg-brand-600 text-white shadow-lg shadow-brand-900/15"
              : "border-brand-200 bg-white text-ink hover:border-brand-500"
          }`}
        >
          Sim
        </button>
        <button
          type="button"
          onClick={() => onAnswer(question.key, false)}
          className={`rounded-2xl border-2 px-6 py-6 text-lg font-semibold transition ${
            value === false
              ? "border-ink bg-ink text-white shadow-lg"
              : "border-brand-200 bg-white text-ink hover:border-gray-400"
          }`}
        >
          Não
        </button>
      </div>

      <button
        type="button"
        onClick={onBack}
        className="mt-10 text-sm font-medium text-gray-500 hover:text-ink px-3 py-3 -ml-3 transition"
      >
        ← Voltar
      </button>
    </section>
  )
}
